export interface Disposition {
  id: number
  disposition: string
  sub_disposition: string | null
  event: string
  created_at: string
  updated_at: string
}

export const dispositionLabel = (d: Disposition): string =>
  d.sub_disposition ? `${d.disposition} - ${d.sub_disposition}` : d.disposition
